import { render, staticRenderFns } from "./LinkSheetToTeacher.vue?vue&type=template&id=34ce1b3e&scoped=true&"
import script from "./LinkSheetToTeacher.vue?vue&type=script&lang=js&"
export * from "./LinkSheetToTeacher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ce1b3e",
  null
  
)

export default component.exports